import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import EventHeader from "./Header";
import { add, isAfter } from 'date-fns';
import MainBlock from "./MainBlock";
import SponsorsBlock from "../../SponsorsBlock";
import ChunkInfiniteScroll from "../../InfiniteScroll/ChunkInfiniteScroll";
import EventListItem from "../ListItem";
import AdvertiseBlock from "../../AdvertiseBlock";
import { useMetaTags } from '../../../services/useMetaTags';
import trackPageView from "../../../services/trackPageView";
import {useEffect} from "react";

export default function Event({event, userData, childEvents, eventDataUpdate}) {
    const {
        id,
        name,
        image,
        locations,
        imageFile,
        information,
        paymentRequired,
        registrationRequired,
        dateStart,
        dateEnd,
        survey,
        prices,
        organizers,
        countriesParticipants,
        phones,
        emails,
        sites,
        sponsors,
        sponsorBlockName,
        youtubeVideoId,
        isKeepVideoAfterFinish,
        metaDataNew
    } = event;
    const {
        isUserCheckedIn,
        isUserRegistered,
        isInFavorite,
        ticket
    } = userData;
    const { t } = useTranslation();
    useMetaTags({
        title: metaDataNew && metaDataNew.title ? metaDataNew.title : name,
        description: metaDataNew && metaDataNew.description ? metaDataNew.description : null,
        metas: [
            { name: 'keywords', content: metaDataNew && metaDataNew.keywords ? metaDataNew.keywords : t('app.keywords') }
        ],
    });
    useEffect(() => {
        trackPageView(name);
    })
    const isStarted = isAfter(new Date(), new Date(dateStart));
    const tickets = typeof event.tickets === 'object' ? Object.values(event.tickets) : event.tickets;
    const isFinished = isAfter(new Date(), add(new Date(dateEnd), {days: 1}));
    const isRegistrationAvailable = registrationRequired && !isFinished && !isUserRegistered;
    const isSurveyAvailable = !!survey;
    const hasChildEvents = !!childEvents.length;
    const imagePath = imageFile?.relativePath || image || '';
    const imageSource = imagePath ? `/${imagePath.replace(/^\//, '')}` : '/img/fallback-min.png';

    return (
        <section>
            <div className="conference-img" style={{backgroundImage: `url(${imageSource})`}} />
            <div className="container conference-container">
                <AdvertiseBlock
                    unitId="conferencePage1"
                    blockLocation="top1"
                    entityId={id}
                />
                <div className="row">
                    <nav className="breadcrumbs">
                        <ul>
                            <li>
                                <Link to="/conferences">{t('conferences.header')}</Link>
                            </li>
                            <li className="active" aria-current="page">
                                { name.length > 35 ? name.substring(0, 35) + '...' : name }
                            </li>
                        </ul>
                    </nav>
                </div>
                <div className="conference-page-wrap">
                    <EventHeader
                        id={id}
                        name={name}
                        image={image}
                        imageFile={imageFile}
                        paymentRequired={paymentRequired}
                        registrationRequired={registrationRequired}
                        isStarted={isStarted}
                        isFinished={isFinished}
                        isUserCheckedIn={isUserCheckedIn}
                        isUserRegistered={isUserRegistered}
                        isRegistrationAvailable={isRegistrationAvailable}
                        isSurveyAvailable={isSurveyAvailable}
                        isInFavorite={isInFavorite}
                        prices={prices}
                        tickets={tickets}
                        userTicket={ticket}
                        eventDataUpdate={eventDataUpdate}
                        youtubeVideoId={youtubeVideoId}
                        isKeepVideoAfterFinish={isKeepVideoAfterFinish}
                    />
                    <MainBlock
                        id={id}
                        description={information}
                        organizers={organizers}
                        countriesParticipants={countriesParticipants}
                        phones={phones}
                        emails={emails}
                        sites={sites}
                        dateStart={dateStart}
                        dateEnd={dateEnd}
                        locations={locations}
                        hasChildEvents={hasChildEvents}
                    />
                    <SponsorsBlock
                        sponsors={sponsors}
                        sponsorBlockName={sponsorBlockName}
                    />
                    { !!locations.length &&
                        <div id="location-map" className="location-map">
                            <iframe
                                title={'conferenceMap'}
                                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAh7pX8v-gZQZTgwnd0zSLGRFTnCTzRIUQ&q=${locations[0].city},${locations[0].street},${locations[0].house}`}
                                frameBorder="0"
                                allowFullScreen
                            />
                        </div>
                    }
                </div>
                {
                    hasChildEvents &&
                    <div className="conferences-list-grid group">
                        <ChunkInfiniteScroll
                            Component={EventListItem}
                            items={childEvents}
                            cancel={true}
                        />
                    </div>
                }
            </div>
        </section>
    )
}
